import React, { useContext } from 'react';

import { Select } from 'antd';
import _ from 'lodash';

import { UserContext } from '@contexts/UserContext';

import useAccountingGroupDepartments from '@hooks/CachedLists/UseAccountingGroupDepartments';

const DepartmentSelector = ({ onChange, mode, value, emptyValue, label }) => {
    const { currentUser } = useContext(UserContext);
    const departmentsObject = useAccountingGroupDepartments();

    const renderOptions = () => {
        if (departmentsObject.isSingleAgency) {
            return (
                <>
                    {emptyValue && (
                        <Select.Option value={null} label="All Departments">
                            All Departments
                        </Select.Option>
                    )}
                    {departmentsObject.departments.map(({ Name, ID }) => (
                        <Select.Option key={ID} value={ID} label={Name}>
                            {Name}
                        </Select.Option>
                    ))}
                </>
            );
        } else {
            const departmentsGrouped = _.groupBy(departmentsObject.departments, 'networkAgencyName');
            const departmentsOptions = Object.entries(departmentsGrouped).map(([agency, depts]) => ({
                agency,
                depts: depts.map(({ ID, Name }) => ({
                    Name: Name,
                    ID: ID,
                })),
            }));
            return (
                <>
                    {emptyValue && (
                        <Select.Option value={null} label="All Departments">
                            All Departments
                        </Select.Option>
                    )}
                    {departmentsOptions.map(({ agency, depts }) => (
                        <Select.OptGroup key={agency} label={agency}>
                            {depts.map(({ Name, ID }) => (
                                <Select.Option key={ID} value={ID} label={`${agency} / ${Name}`}>
                                    {Name}
                                </Select.Option>
                            ))}
                        </Select.OptGroup>
                    ))}
                </>
            );
        }
    };

    return (
        <Select
            autoComplete="off"
            mode={mode}
            value={value ? value : emptyValue ? null : currentUser.ActiveContext.depId}
            label={label ? label : 'Department'}
            style={{ width: '100%', minWidth: '200px' }}
            placeholder="Select Departments"
            onChange={onChange}
            allowClear={false}
            getPopupContainer={(triggerNode) => triggerNode.parentNode}
            optionLabelProp="label"
        >
            {renderOptions()}
        </Select>
    );
};

export default DepartmentSelector;
